import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import Http from '../../../../Http';
import { Button, TextField, Snackbar, Slide, IconButton, Icon } from '@material-ui/core';
import { Validators } from '../../../../components/form/DynamicFormTs';

class ClienteDatosContactos extends Component {

  state = {
    contactoTipos: [],
    contactos: [],
    sbOpen: false,
    sbMsg: '',
    id_cliente: null
  }

  componentDidMount() {
    this.setState({
      id_cliente: this.props.id_cliente || this.props.match.params.id
    }, () => {
      this.loadContactos();
    })
    // this.loadFormData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id_cliente !== this.props.id_cliente) {
      this.setState({
        id_cliente: this.props.id_cliente
      }, () => {
        this.loadContactos();
      })
    }
  }

  /* loadFormData = async () => {
    let Res = await Http.get('cliente/form-contactos');
    console.log(Res.data)
    if (!Res.error) {
      this.setState({ contactoTipos: Res.data.contacto_tipos })
    }
    this.loadContactos();
  } */

  loadContactos = async () => {
    let Res = await Http.get(`cliente/contactos-cfdi?c=${this.state.id_cliente}`);
    if (!Res.error) {
      this.setState({ contactos: Res.data })
    }
  }

  agregarContacto = () => {
    let contactos = this.state.contactos;
    if (contactos.length >= 4) return;
    contactos.push({
      id_cliente: this.state.id_cliente,
      nombre: '',
      email: '',
      id: null,
    })
    this.setState({ contactos })
  }

  conctactoChange = (i, prop, value) => {
    let contactos = this.state.contactos;
    contactos[i][prop] = value;
    this.setState({ contactos })
  }

  guardar = async () => {
    console.log(this.state.contactos)
    if (this.state.contactos.length < 1) return;
    let contactos = this.state.contactos;
    // VALIDAR CAMPOS
    for (var i in contactos) {
      if (contactos[i].nombre.length < 2 || !Validators.email(contactos[i].email)) {
        this.setState({ sbMsg: `Datos no válidos en contacto #${parseInt(i) + 1}`, sbOpen: true })
        return;
      }
      // console.log(contactos[i])
    }
    let Res = await Http.post('cliente/contactos-cfdi/save', { contactos });
    console.log(Res)
    if (!Res.error) {
      this.setState({ contactos: Res.data, sbMsg: 'Contactos guardados', sbOpen: true })
    }

  }

  contactoDelete = async (idx) => {
    let Res = await Http.post('cliente/contacto-cfdi/delete', { id: this.state.contactos[idx].id });
    if (!Res.error) {
      this.setState({ sbMsg: `Contacto ${this.state.contactos[idx].nombre} eliminado`, sbOpen: true })
      // this.setState({ contactos: Res.data })
      this.loadContactos();
    }
  }

  render() {
    const { contactos, sbOpen, sbMsg } = this.state;
    return (
      <div>
        <div className='form-box'>
          <h4>Datos de contactos CFDI</h4>
          <div style={{ textAlign: 'right', paddingTop: 10, paddingBottom: 10 }}>
            <Button variant="contained" color="primary" onClick={this.agregarContacto}>Agregar contacto</Button>
          </div>
          <div className='preguia-detalles-paquetes'>
            <div hidden={contactos.length > 0} style={{ textAlign: 'center' }}>SIN CONTACTOS</div>
            {contactos.map((conctacto, i) => (
              <div className='row' key={i}>
                <div className='col-12 col-sm-6'>
                  <TextField className='form-field' type='text' label="Contacto" value={conctacto.nombre || ''} variant="outlined" onChange={(e) => { this.conctactoChange(i, 'nombre', e.target.value) }} />
                </div>
                <div className='col-12 col-sm-5'>
                  <TextField className='form-field' type='text' label="Email" value={conctacto.email || ''} variant="outlined" onChange={(e) => { this.conctactoChange(i, 'email', e.target.value) }} />
                </div>
                <div className='col-12 col-sm-1 preguia-detalles-delete'>
                  <IconButton onClick={() => { this.contactoDelete(i) }}>
                    <Icon>remove_circle</Icon>
                  </IconButton>
                </div>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'right', paddingTop: 10, paddingBottom: 10 }}>
            <Button variant="contained" color="primary" onClick={this.guardar}>Guardar contactos</Button>
          </div>

          <Snackbar
            open={sbOpen}
            onClose={() => { this.setState({ sbOpen: false }) }}
            TransitionComponent={Slide}
            message={<span>{sbMsg}</span>}
          />
        </div>
      </div>
    )
  }
}

export default withRouter(ClienteDatosContactos)
